<template>
	<splash v-show="isLoading" title="코어독해 준비중..." />
	<splash v-show="isProc" title="잠시만 기다려 주세요." />
	<studyHeader v-if="!isLoading" />
	<q-page-container v-if="!isLoading" class="color_gray_900">
		<q-page
			v-if="!videoStudy && !isKreadVisible"
			class="pd_all_16"
			style="height: calc(100vh - 9.83vmin)"
		>
			<div class="row">
				<div class="col passage" :class="{ pd_bottom_120: problemOrder === 0 }">
					<qbankHeaderVue
						v-if="!isKreadVisible"
						:questionHeader="questionHeader"
						:inputIdx="inputIdx"
						@stopNoti="stopNoti"
						@setInputAnswer="setInputAnswer"
						:bookNm="bookNm"
						@isChangeHeader="
							() => {
								isChangeHeader = true;
							}
						"
					/>
				</div>
				<div v-if="problemOrder > 0 && problem" class="col answer">
					<q-scroll-area
						ref="scrollAreaRef"
						visible
						style="height: calc(100% - 1.99vmin)"
						class="answer__scroll"
					>
						<div>
							<qbankProblem
								:p-content="problem"
								v-if="problem"
								@onChangeProblems="onChangeProblems"
								@setInputAnswer="setInputAnswer"
								:answer="answer"
							/>
							<!-- <div v-html="testAnswer"></div> --><!-- 임시 정답 표시 -->
						</div>
						<!-- 정답표기 -->
						<div>
							<template v-if="visibleAnswer">
								{{ problem.data.content.solution.answer.texts }}
							</template>
							<qbankAnswer
								v-if="
									problem?.result && problem?.result?.marking !== 'halfWrong'
								"
								:p-content="problem"
								:isCore="true"
							/>
						</div>
					</q-scroll-area>
				</div>
			</div>
		</q-page>
		<div
			v-if="isKreadVisible"
			class="page"
			style="
				height: calc((var(--vh, 1vh) * 100) - (2.4vw + (1.58vmin * 2) + 2px));
			"
		>
			<q-badge
				rounded
				:label="
					(studyStore.process.exam?.areaCode === '01' ? '문학' : '비문학') +
					' 지문' +
					(studyStore.process.examIdx === 0 || studyStore.process.examIdx === 2
						? 1
						: 2)
				"
			/>
			<p v-if="data?.kread" class="display_flex mg_bottom_24 kread__logo">
				<!-- <div>Kread </div> -->
				<span class="kread__img"
					><img src="@/assets/images/main/kread_green.png"
				/></span>
				<span class="kread__number">{{ data?.kread }}</span>
			</p>
			<h2 class="h1 bold txt_center line_height_66">{{ data?.title }}</h2>
			<p class="b2 txt_center line_height_42 sub-title">
				이번 지문을 읽기 위해 권장되는 시간은
				<span class="color_primary">{{ data?.standardReadingTime }}</span
				>입니다.
				<!-- {{}}읽기 실력 향상을 위해 -->
			</p>
			<!-- <div style="width: 100%; height: calc((var(--vh, 1vh) * 100) - 360px);; display: flex; justify-content: center;"> -->
			<!-- <div style="width: 100%; height: 40vh; display: flex; justify-content: center;"> -->

			<div class="chart__txt">
				<wordCahrt :chartText="data.content?.replaceAll('br', '')" />
			</div>
			<div class="display_flex chart__list">
				<p class="chart__item" v-if="data.item?.headerBookDesc">
					글자 수
					<span>{{ data.item?.headerBookDesc }}</span>
				</p>
				<q-separator vertical inset v-if="data.item?.headerEtcTxt05" />
				<p class="chart__item" v-if="data.item?.headerEtcTxt05">
					문단 수
					<span>{{ data.item?.headerEtcTxt05 }}</span>
				</p>
				<q-separator vertical inset v-if="data.item?.headerKeyword" />
				<p class="chart__item" v-if="data.item?.headerKeyword">
					문장 수
					<span>{{ data.item?.headerKeyword }}</span>
				</p>
				<q-separator vertical inset v-if="data.item?.headerEtcTxt07" />
				<p class="chart__item" v-if="data.item?.headerEtcTxt07">
					복문 수
					<span>{{ data.item?.headerEtcTxt07 }}</span>
				</p>
			</div>
			<!-- <p class="b3 medium color_gray_600 txt_center line_height_32 page__txt">{{
          userStore.userInfo.studentName
      }}님의 읽기 실력 향상을 위해 지문읽기 시간을 측정하여 알려드릴게요!</p> -->
			<p class="b3 medium color_gray_600 txt_center line_height_32 page__txt">
				권장 시간 안에 지문을 정확하게 이해하며 읽어 보세요.
			</p>
			<p class="page__btn">
				<!-- 존재하는 컴포넌트로 변경함
                <q-btn unelevated label="읽기 시작" color="primary" :onclick="startTimer" />    
                    -->
				<CqBtn
					:options="{ label: '읽기 시작', color: 'primary' }"
					@on-click-fn="startTimer"
				/>
			</p>
		</div>
		<div v-if="videoStudy" style="height: calc(100vh - 9.83vmin)">
			<transition
				appear
				enter-active-class="animated fadeIn"
				leave-active-class="animated fadeOut"
			>
				<div v-if="videoHeader" class="modal-model">
					<q-card style="border-radius: 3.33vmin; padding: 20px">
						<q-card-section
							class="row items-center q-pb-none"
							style="padding: 10px"
						>
							<q-space />
							<q-btn
								class="close"
								icon="close"
								flat
								round
								dense
								:onclick="
									() => {
										videoHeader = false;
									}
								"
							/>
						</q-card-section>
						<div style="height: calc((var(--vh, 1vh) * 100) - 184px)">
							<q-scroll-area
								ref="scrollAreaRef"
								visible
								style="height: 100%; padding: 0px 10px"
							>
								<div v-html="questionHeader" />
							</q-scroll-area>
						</div>
					</q-card>
				</div>
			</transition>
			<!-- <VideoTest videoSrc="https://media5jvqbd.fmkorea.com/files/attach/new2/20210301/2063168106/62449231/3424305738/b1b4e7075cece7bf3b0174253e99b524.mp4#t=1, 10" /> -->
			<VideoTest
				:videoSrc="videoUrl"
				:isDone="videoComplete"
				@onPlaying="onVideoPlaying"
				@setVideoStatus="onVideoStatus"
			/>
			<FloatingBtn
				:visible="!videoHeader && !nextBtn"
				text="지문 확인"
				text-only="true"
				bgColor="#FF4E7C"
				:onclick="
					() => {
						videoHeader = true;
					}
				"
				class="answer--txt"
			/>
			<!-- <FloatingBtn :visible="!videoHeader" text="지문 확인" text-only="true" bgColor="#FF4E7C"
        bottom="calc( 15.83vmin - 4.9vw - 0.83vmin )" :onclick="() => { videoHeader = true; }" class="answer--txt" /> -->
		</div>
		<FloatingNotify
			:text="msg"
			@resetMsg="
				() => {
					msg = '';
				}
			"
		/>
		<!-- <FloatingBtn :visible="nextBtn" @on-click="() => { nextStep(); }" /> -->
		<FloatingBtn
			:visible="nextBtn"
			:text="
				nextBtn &&
				problemOrder === 3 &&
				(videoUrl === null || (videoStudy && videoComplete))
					? '코어독해 완료'
					: null
			"
			:bgColor="
				nextBtn &&
				problemOrder === 3 &&
				(videoUrl === null || (videoStudy && videoComplete))
					? '#222222'
					: null
			"
			:icon="
				nextBtn &&
				problemOrder === 3 &&
				(videoUrl === null || (videoStudy && videoComplete))
					? 'done'
					: null
			"
			@on-click="
				() => {
					nextBtn && nextStep();
				}
			"
			:class="
				nextBtn &&
				problemOrder === 3 &&
				(videoUrl === null || (videoStudy && videoComplete))
					? 'answer--txt'
					: 'answer--next'
			"
		/>
		<FloatingBtn
			:visible="preBtn"
			position="left"
			@on-click="onClickPreBtn"
			class="answer--prev"
		/>
		<FloatingBtn
			:visible="readBtn"
			icon="done"
			text="읽기 완료"
			bgColor="#222222"
			@on-click="onCompletedReading"
			class="answer--txt"
			bottom="2.5vmin"
		/>
		<FloatingBtn
			:visible="scoreBtn"
			:text="problemOrder === 2 ? '모델답안 확인' : '정답 확인'"
			text-only="true"
			bgColor="#FF4E7C"
			@on-click="
				() => {
					scoreBtn && setEsasyQuestionsResult();
				}
			"
			class="answer--txt"
			bottom="calc( 15.83vmin - 4.9vw - 0.83vmin )"
		/>
	</q-page-container>

	<!-- <modalLayer v-if="store.visibleModal" :width="isKreadVisible ? '90%' : '400px'"> -->
	<q-dialog
		v-model="dStore.visibleModal"
		persistent
		class="confirm reading__modal"
	>
		<q-card class="color_gray_900">
			<h3 class="h3 bold txt_center line_height_48">나의 읽기 시간</h3>
			<h3 class="h3 bold txt_center line_height_48" style="color: #18b73f">
				{{ time }}
			</h3>
			<!-- <p class="b3 txt_center line_height_32">권장 읽기 시간은 <span class="bold color_primary">{{ data?.standardReadingTime
      }}</span>입니다 </p> -->
			<p class="txt_center clock__img">
				<q-img
					spinner-color="lightgrey"
					src="/assets/images/icon/ico_stopwatch_green.png"
					alt="splash"
				/>
			</p>
			<p class="b3 txt_center line_height_32" style="white-space: pre-wrap">
				<!-- 권장 읽기 시간보다 {{ diffTime > 0 ? diffTime + '초 빨리' : (diffTime * -1) + '초 늦게' }} 읽었네요!<br /> -->
				{{ setSolveTimeMessage() }}<br />
				<!-- 지문을 분석하며 문제를 풀어보아요. -->
			</p>
			<p class="txt_center reading__btn">
				<!-- 존재하는 컴포넌트로 변경함
                <q-btn unelevated label="코어독해 시작" color="primary" :onclick="nextStep" />    
                    -->
				<CqBtn
					:options="{ label: '코어독해 시작', color: 'primary' }"
					@on-click-fn="nextStep"
				/>
			</p>
		</q-card>
	</q-dialog>
</template>

<script setup>
import { getTimeStringSecondsKor, historyBack } from '@/helpers/utils';
import splash from '@/components/template/splash.vue';
import { ref, onMounted, onUnmounted, watch, toRaw } from 'vue';
import { DialogStore } from '@/store/modules/dialog';
import modalLayer from '@/components/layouts/layer/modalLayer.vue';
import qbankHeaderVue from '@/components/qbank/header.vue';
import qbankProblem from '@/components/qbank/problem.vue';
import qbankAnswer from '@/components/qbank/qbankAnswer.vue';
import studyHeader from '@/components/layouts/header/studyHeader.vue';
import wordCahrt from '@/components/chart/wordCahrt.vue';
import { getKrtExam, getKrtHeaders, getKrtProblem } from '@/api/modules/qbank';
import dataToParse from '@/helpers/qbankParser/dataParse';
import {
	getHeaderTitle,
	getAnswer as getAn,
	getHeaderText,
	getEtcInfo,
	getHeader,
} from '@/helpers/qbankParser/qbankDataParse';
import { useQuasar } from 'quasar';
import moment from 'moment';
import { soundEffect, soundTic } from '@/helpers/soundEffect';
import { StudyStore } from '@/store/modules/study';
import { useRouter, useRoute } from 'vue-router';
import CqBtn from '@/components/quasar/cqBtn.vue';
import {
	postAnswer,
	postCornerStart,
	postPassageTime,
	postVideoTime,
	postCornerEnd,
	getAnswer,
	checkProgress,
	callNewDreamsStartTime,
} from '@/api/modules/study';
import { stringLiteral } from '@babel/types';
import { postUserJson } from '@/api/modules/login';
import { GlobalStore } from '@/store';
import FloatingBtn from '@/components/quasar/floatingBtn.vue';
import FloatingNotify from '@/components/quasar/floatingNotify.vue';
import VideoTest from '@/components/qbank/VideoTest.vue';
import { learningType } from '@/helpers/qbankParser/qbankMeta';
import {
	monitoringLog,
	monitoringTodayLearningStudy,
} from '@/api/modules/monitoring';

const visibleAnswer = ref(false);
const isLog = true;
const onVideoPlaying = bool => {
	//2023-11-24 pby 영상 상태 유무 확인으로 컨트롤 여부 확인
	if (studyStore.videoStatus === 'C') {
		videoComplete.value = true;
		nextBtn.value = true;
	}

	if (
		process.env.NODE_ENV === 'local' ||
		process.env.NODE_ENV === 'development' ||
		process.env.NODE_ENV === 'qa'
	) {
		videoComplete.value = true;
		nextBtn.value = true;
	}
};
const onVideoStatus = xxVideoStartTime => {
	videoComplete.value = true;
	nextBtn.value = true;
	if (isLog) console.log('-CORE- c1111-nextBtn.    -', nextBtn.value);

	preBtn.value = true;
};

const onClickPreBtn = () => {
	preBtn.value && nextStep(false);
};

// 학습준비화면 시간
const loadingTime = 1000;
const $q = useQuasar();
const router = useRouter();
const route = useRoute();
const dStore = DialogStore();
const studyStore = StudyStore();
const gStore = GlobalStore();
const isLoading = ref(null);
const isProc = ref(null);
const isKreadVisible = ref(false);
const msgVisible = ref(true);
const data = ref(null);
const diffTime = ref(0);
let startTime;
let baseTime;
let startTsGlobal;
const time = ref(null);
const questionHeader = ref(null);
const bookNm = ref(null);
const videoStudy = ref(false);
let problems = {};
let inputIdx = ref(0);
let answer = ref({});
let tmpAnswer = ref({});

//TODO: 차후 스토어로 변경 필요
const problemOrder = ref(0);
const problem = ref(null);
let notiAnswer = null;
let notiType = 'first';
let isTooFast = false;

const nextBtn = ref(false);
const preBtn = ref(false);
const readBtn = ref(false);
const scoreBtn = ref(false);
const msg = ref('');
const videoUrl = ref('');
const videoComplete = ref(false);
const videoHeader = ref(false);
const isChangeHeader = ref(false);
const testAnswer = ref('');

let isViewMode = false;

let cornerTime = {
	passageReadStartTs: null,
	passageReadEndTs: null,
	passageReadTime: 0,
	videoViewStartTs: null,
	videoViewEndTs: null,
	videoViewTime: 0,
	cornerLearningStartTs: null,
	cornerLearningEndTs: null,
	cornerLearningTime: 0,
};
let videoTime = {
	videoViewStartTs: null,
	videoViewEndTs: null,
	videoViewTime: 0,
};
let cornerLearningBaseTime = null;

let learningDataList = ref([]);

const initCoreReading = (rs, sdata) => {
	getKrtHeaders(
		{
			// version: '1.00.01', examNm: 'KRT_02_17_N_02_C'
			version: studyStore.exprVersion,
			examNm: studyStore.process.exam.examCode + '_C',
		},
		r => {
			questionHeader.value = null; //2023-11-07 pby 문제 데이터 초기화 추가.
			console.log('core befor: ' + questionHeader.value);
			const tmpHeaderData = r.examMaps[r.examIds[0]]
				.filter(i => i.problemId === rs.content.problemId)
				.pop();

			isLoading.value = false;
			if (!sdata) {
				isKreadVisible.value = true;
			}

			// store.openModal(true);
			const tmpEtcInfo = getEtcInfo(rs);
			data.value = {
				content: getHeaderText(rs),
				kread: tmpEtcInfo.kread,
				title: tmpEtcInfo.title,
				etcInfo: tmpEtcInfo,
				// standardReadingTime: moment('2022-10-01 00:00:00').add(tmpEtcInfo.solveTime, 's').format('m분ss초'),
				standardReadingTime: getTimeStringSecondsKor(tmpEtcInfo.solveTime),
				solveTime: tmpEtcInfo.solveTime,
				item: tmpHeaderData ? tmpHeaderData.property : null,
			};
			questionHeader.value = getHeader(rs);
			console.log('core after: ' + questionHeader.value);
			bookNm.value = tmpEtcInfo.bookNm;
		}
	);
};

const onCompletedReading = () => {
	let elapsedTime = moment
		.duration(moment().diff(moment(startTsGlobal)))
		.asSeconds();
	// console.log(`-CORE- -onCompletedReading-elapsedTime-`, elapsedTime);

	// 30초 보다 빠르면서, 메시지를 보지 못한 경우
	if (elapsedTime < 30 && !isTooFast) {
		isTooFast = true;
	} else {
		// 30초 이상이거나, 메시지를 1회 보았을 경우
		isTooFast = false;
	}
	readBtn.value && stopTimer();
};
const nextStep = (v = true) => {
	isProc.value = true;
	soundEffect('next');
	// problems[problemOrder.value]['cornerEndTs'] = moment().format('YYYY-MM-DD HH:mm:ss');
	// problems[problemOrder.value]['cornerElapsedTime'] = problems[problemOrder.value]['cornerElapsedTime'] + moment.duration(moment().diff(startTime)).asSeconds();

	if (notiType === 'last' && v) {
		// 학습 완료
		// 학습 데이터 저장
		if (videoUrl.value !== null) {
			if (videoStudy.value) {
				if (videoComplete.value) {
					//영상 시청시간 관련
					let item = learningDataList.value.find(function (element) {
						return element.id === studyStore.process.exam.examCode + '_C';
					});
					if (item) {
						let endTs = Date.now();
						item.videoViewEndTs = endTs;
						item.videoViewTime = item.videoViewEndTs - item.videoViewStartTs;
						item.videoViewEndTime = moment(endTs).format('YYYY-MM-DD HH:mm:ss');
						videoTime.videoViewEndTs = item.videoViewEndTime;
						videoTime.videoViewTime = item.videoViewTime;
					}
					if (!isViewMode) {
						postVideoTime(
							{
								examName: studyStore.process.exam.examCode + '_C',
								learningType: studyStore.process.exam.learningType,
								...videoTime,
							},
							() => {
								// 비디오 시간 저장
							}
						);
					}
					problems[problemOrder.value]['cornerStartTs'] =
						videoTime.videoViewStartTs;
					problems[problemOrder.value]['cornerEndTs'] =
						videoTime.videoViewEndTs;
					problems[problemOrder.value]['cornerElapsedTime'] = moment
						.duration(moment().diff(moment(videoTime.videoViewStartTs)))
						.asMilliseconds();
					return submitAnswer(problemOrder.value, true);
				}
			} else {
				//영상 시청시간 관련
				let item = learningDataList.value.find(function (element) {
					return element.id === studyStore.process.exam.examCode + '_C';
				});
				let startTs = Date.now();
				if (item) {
					item.videoViewStartTs = startTs;
					item.videoViewStartTime = moment(startTs).format(
						'YYYY-MM-DD HH:mm:ss'
					);
					videoTime.videoViewStartTs = item.videoViewStartTime;
				} else {
					//
					const learningData = {
						id: studyStore.process.exam.examCode + '_C',
						type: 'passageRead',
						videoViewStartTs: startTs,
						videoViewStartTime: moment(startTs).format('YYYY-MM-DD HH:mm:ss'),
					};
					learningDataList.value.push(learningData);
					videoTime.videoViewStartTs = learningData.videoViewStartTime;
				}
				if (isLog) console.log('-CORE- -nextStep  q2222-');

				console.log('3problemPage nextBtn', problemOrder.value);
				submitAnswer(problemOrder.value);
				if (videoComplete.value) {
					nextBtn.value = true;
					if (isLog) console.log('-CORE- c2222-nextBtn.    -', nextBtn.value);

					preBtn.value = true;
				} else {
					nextBtn.value = false;
					if (isLog) console.log('-CORE- c3333-nextBtn.    -', nextBtn.value);

					preBtn.value = false;
				}
				msg.value = '선생님의 작품 해설 강의를 확인해 보세요.';
				isProc.value = false;
				return (videoStudy.value = true);
			}
		} else {
			if (isLog) console.log('-CORE- -nextStep  q3333-');
			return submitAnswer(problemOrder.value, true);
		}
	}
	if (notiType === 'last' && !v && videoStudy.value) {
		return (videoStudy.value = false);
	}
	//중간 저장
	if (problemOrder.value !== 0) {
		console.log('1,2problemPage nextBtn', problemOrder.value);
		submitAnswer(problemOrder.value);
	}
	if (!v) {
		if (problemOrder.value > 1) {
			problemOrder.value = problemOrder.value - 1;
		}
	} else {
		problemOrder.value = problemOrder.value + 1;
	}

	startTime = moment();
	if (problems[problemOrder.value]['answerStartTs'] === null) {
		problems[problemOrder.value]['answerStartTs'] = moment().format(
			'YYYY-MM-DD HH:mm:ss'
		);
	}

	if (problems[problemOrder.value]['cornerStartTs'] === null) {
		problems[problemOrder.value]['cornerStartTs'] = moment().format(
			'YYYY-MM-DD HH:mm:ss'
		);
	}

	if (problemOrder.value === 1) {
		if (isLog) console.log('-CORE- -nextStep  q4444-');
		notiType = 'first';
		dStore.openModal(false);
		questionHeader.value = getHeader(problems[problemOrder.value].data);
		preBtn.value = false;
	} else if (problemOrder.value === Object.keys(problems).length - 1) {
		if (isLog) console.log('-CORE- -nextStep  q5555-');
		notiType = 'last';
	} else {
		if (isLog) console.log('-CORE- -nextStep  q6666-');
		notiType = 'middle';
	}

	problem.value = {
		...problems[problemOrder.value],
	};

	//  2024-01-15 ljs 코어독해 첫 문제 하이라이팅 후 답입력 선택란 표출되도록 추가
	highlightInputAnswer();
	if (!problems[problemOrder.value]['completeYn']) {
		preBtn.value = false;
		nextBtn.value = false;
		if (isLog) console.log('-CORE- c4444-nextBtn.    -', nextBtn.value);
	} else {
		notiType !== 'first' && (preBtn.value = true);
		if (isLog) console.log('-CORE- c5555-nextBtn.    -', nextBtn.value);

		nextBtn.value = true;
	}

	tmpAnswer.value = {};
	testAnswer.value = getAn(problems[problemOrder.value].data).texts;
	isProc.value = false;
	//이때 잠시만 기다려주세요가 빠지고 학습이로드된 시간
	//그럼 학습시작시간은 여기서 부터 체크해야함
	let startTs = Date.now();
	const learningData = {
		problemId: problems[problemOrder.value].problemId,
		type: 'core',
		startTs: startTs,
		startTime: moment(startTs).format('YYYY-MM-DD HH:mm:ss'),
		endTime: null,
		learningHistorySeq: studyStore.process.learningHistorySeq,
	};
	learningDataList.value.push(learningData);
};
// 2024-01-15 ljs 코어독해 첫 문제 하이라이팅 후 답입력 선택란 표출되도록 추가
const highlightInputAnswer = () => {
	const inputTypes = ['60', '61', '70'];
	if (
		inputTypes.includes(
			problems[problemOrder.value].data.content.property.problem.typeCd
		)
	) {
		let maxOrd = 0;
		problems[problemOrder.value].data.content.solution.answer.detail.forEach(
			i => {
				maxOrd = i.ord > maxOrd ? i.ord : maxOrd;
			}
		);
		// inputIdx.value = problems[problemOrder.value].data.content.solution.answer.texts.length;
		inputIdx.value = maxOrd;
	}
};

const initExams = (sdata = null, exCode = null) => {
	if (isLog)
		console.log('-CORE- g11111-initExams. sdata  exCode -', sdata, exCode);

	getKrtExam(
		{
			// version: '1.00.01', examNm: 'KRT_02_17_N_02_C'
			version: studyStore.exprVersion,
			examNm: exCode ? exCode + '_C' : studyStore.process.exam.examCode + '_C',
		},
		async rs => {
			// TODO: store 에 코어리딩 문제 저장
			// rs.examMaps
			if (rs.examMaps) {
				const exId = rs.examIds[0];
				const problemArr = rs.examMaps[exId];
				if (isLog)
					console.log('-CORE- g11111-initExams.    problemArr -', problemArr);

				let sOrder = studyStore.process?.exam?.isReadPassage ? 1 : 0;
				if (sdata) {
					let sdataIdxs = [];
					sdata.forEach(i => {
						if (isLog) console.log('-CORE- ff1111-forEach.    e -', i);
						sdataIdxs.push(i.problemId);
					});
					if (isLog)
						console.log('-CORE- ff1111-sdataIdxs.  sdataIdxs -', sdataIdxs);

					problemArr.forEach((item, index) => {
						if (isLog)
							console.log('-CORE- ff2222-forEach. item -', index, item);
						if (sdataIdxs.includes(item.problemId)) {
							if (isLog)
								console.log('-CORE- ff3333-forEach. item -', item.problemId);
							sOrder = index;
						}
					});
					if (isLog) console.log('-CORE- g2222- . sOrder -', sOrder);
				}
				await Promise.all(
					problemArr.map((item, index) => {
						return getKrtProblem(
							{
								version: studyStore.exprVersion,
								problemId: item.problemId,
							},
							r => {
								let pData = {
									problemId: r.content.problemId,
									completeYn: false,
									data: r,
									elapsedTime: 0,
									answer: {},
									correctYn: null,
									reAnswer: null,
									reCorrectYn: null,
									result: null, //'right': 정답, 'halfWrong':1차오답 , 'halfRight':2차정답 , 'wrong':2차오답
									answerStartTs: null,
									answerEndTs: null,
									problemClassCode: '1',
									rightAnswer: r.content.solution.answer.detail,
									cornerStartTs: null,
									cornerEndTs: null,
									cornerElapsedTime: null,
								};

								if (sdata) {
									const tmpData = [...sdata]
										.filter(i => i.problemId === r.content.problemId)
										.pop();
									if (isLog)
										console.log('-CORE- initexam2222-tmpData.    -', tmpData);

									if (tmpData) {
										pData = {
											...pData,
											completeYn: tmpData.completeYn,
											elapsedTime: tmpData.elapsedTime,
											answer: JSON.parse(tmpData.answer),
											correctYn: tmpData.correctYn,
											reAnswer: JSON.parse(tmpData.reAnswer),
											reCorrectYn: tmpData.reCorrectYn,
											result: {
												marking:
													index === 2
														? ''
														: tmpData.correctYn
														? 'right'
														: tmpData.reCorrectYn
														? 'halfRight'
														: 'wrong',
												answer: tmpData.correctYn
													? JSON.parse(tmpData.answer)
													: JSON.parse(tmpData.reAnswer),
											},
											answerStartTs: tmpData.answerStartTs,
											answerEndTs: tmpData.answerEndTs,
											problemClassCode: tmpData.problemClassCode,
											//cornerStartTs: tmpData.cornerStartTs,
											// cornerEndTs: tmpData.cornerEndTs,
											// cornerElapsedTime: tmpData.cornerElapsedTime,
										};
									}
								}

								problems = {
									...problems,
									[index]: pData,
								};
								if (isLog)
									console.log(
										'-CORE- initexam2222-problems.    -',
										index,
										problems
									);

								if (index === 3) {
									if (isLog) console.log('-CORE--initexam3333 -');

									videoUrl.value = r.content.property.problem.listen.includes(
										'mp4'
									)
										? process.env.VUE_APP_DS_QBANK_ASSET_URL +
										  r.content.property.problem.listen
										: null;
									// if(isLog) console.log('-aaaa-videoUrl--',videoUrl.value)
									// videoUrl.value = process.env.VUE_APP_DS_QBANK_ASSET_URL + '/bank/object/KRT_03_01_L_01_C.mp4';
									// videoUrl.value = 'https://media5jvqbd.fmkorea.com/files/attach/new2/20210301/2063168106/62449231/3424305738/b1b4e7075cece7bf3b0174253e99b524.mp4#t=1, 10';
								}

								if (index === 0) {
									if (isLog) console.log('-CORE--initexam0000 -');

									initCoreReading(r, sdata);
									// setProblem(r);
								}
							}
						);
					})
				);
				if (isLog) console.log('-CORE- b6666-nextBtn.    -', sdata, sOrder);

				if (sdata && sOrder) {
					if (isLog)
						console.log(
							'-CORE- f1111-problem.    -',
							problem.value,
							problemOrder.value
						);
					problem.value = problems[sOrder];
					problemOrder.value = sOrder;
					if (isLog)
						console.log(
							'-CORE- f1111222-problem.    -',
							problem.value,
							problemOrder.value
						);
					if (isLog)
						console.log('-CORE- f3333-problems.    -', problems, sOrder);

					if (isLog)
						console.log(
							'-CORE- c6666-problems[sOrder].    -',
							preBtn.value,
							problems[sOrder]
						);
					if (problems[sOrder]?.completeYn) {
						sOrder !== 1 && (preBtn.value = true);
						if (isLog)
							console.log('-CORE- c6666-nextBtn.    -', nextBtn.value, sOrder);
						nextBtn.value = true;
						if (isLog)
							console.log(
								'-CORE- c6666777-nextBtn.    -',
								nextBtn.value,
								sOrder
							);

						if (sOrder === 3) {
							if (studyStore.currentInfo !== null) videoComplete.value = true;
							else videoComplete.value = false;
							notiType = 'last';
						} else if (sOrder === 1) notiType = 'first';
						else notiType = 'middle';
					}
					if (isLog)
						console.log('-CORE- c8888-nextBtn.    -', nextBtn.value, sOrder);
				} else {
					if (isLog) console.log('-CORE- c7777-problem.    -', problem.value);
					problem.value = problems[sOrder];
					if (isLog)
						console.log('-CORE- c7777888-problem.    -', problem.value);

					problemOrder.value = sOrder;
				}
			}
		}
	);
	startTime = moment();
	startTsGlobal = Date.now();
	// console.log('문제 초기화에서 시작시간 할당');
};
watch(
	() => studyStore.process,
	newValue => {
		// isLoading.value = true;
		// isKreadVisible.value = false;
		resetValue();
		setTimeout(() => {
			if (isLog) console.log('-CORE- w7777- .  ');
			initExams();
		}, loadingTime);
	}
);

watch(
	() => studyStore.currentInfo,
	newValue => {
		resetValue();

		if (isLog)
			console.log(
				'-CORE- -learningStatus -',
				studyStore.process.exam.learningStatus
			);

		if (typeof studyStore.currentInfo?.exam === 'object') {
			isViewMode = true;
			getAnswer(
				{
					type: 'core',
					data: {
						examName: studyStore.currentInfo.exam.examCode,
						learningType: studyStore.currentInfo.exam.learningType,
					},
				},
				r => {
					setTimeout(() => {
						if (isLog) console.log('-CORE- w1111- .  ', r);
						initExams(r, studyStore.currentInfo.exam.examCode);
					}, 1000);
				}
			);
		} else {
			if (studyStore.process.exam.learningStatus === 'I') {
				startTime = moment();
				getAnswer(
					{
						type: 'core',
						data: {
							examName: studyStore.process.exam.examCode,
							learningType: studyStore.process.exam.learningType,
						},
					},
					r => {
						setTimeout(() => {
							if (isLog) console.log('-CORE- w2222- .  ', r);
							initExams(r);
						}, 1000);
					}
				);
			} else if (studyStore.process.exam.learningStatus === 'C') {
				getAnswer(
					{
						type: 'core',
						data: {
							examName: studyStore.process.exam.examCode,
							learningType: studyStore.process.exam.learningType,
						},
					},
					r => {
						setTimeout(() => {
							if (isLog) console.log('-CORE- w3333- .  ', r);
							initExams(r);
						}, 1000);
					}
				);
			} else if (studyStore.process.exam.learningStatus === 'W') {
				setTimeout(() => {
					if (isLog) console.log('-CORE- w4444- .  ');
					initExams();
				}, 1000);
			}
		}
	}
);
// 2024-01-15 ljs 코어독해 첫 문제 하이라이팅 후 답입력 선택란 표출되도록 추가
watch(
	() => isChangeHeader.value,
	newValue => {
		highlightInputAnswer();
	}
);

const init = async () => {
	await soundEffect('enter');
	isLoading.value = true;
	isKreadVisible.value = false;
	// setTimeout(() => { initExams(); }, 1000);
	if (isLog)
		console.log(
			'-CORE- init1111-learningStatus -',
			studyStore.process.exam.learningStatus,
			studyStore.currentInfo
		);

	if (typeof studyStore.currentInfo?.exam === 'object') {
		isViewMode = true;
		getAnswer(
			{
				type: 'core',
				data: {
					examName: studyStore.currentInfo.exam.examCode,
					learningType: studyStore.currentInfo.exam.learningType,
				},
			},
			r => {
				setTimeout(() => {
					if (isLog) console.log('-CORE- init1111- r -', r);
					initExams(r, studyStore.currentInfo.exam.examCode);
				}, 1000);
			}
		);
	} else {
		if (studyStore.process?.exam?.orgLearningType) {
			studyStore.setExamLearningType();
		}

		if (studyStore.process.exam.learningStatus === 'I') {
			startTime = moment();
			if (isLog)
				console.log(
					'-CORE- init2222-learningStatus -',
					studyStore.process.exam.learningStatus,
					studyStore.currentInfo
				);

			getAnswer(
				{
					type: 'core',
					data: {
						examName: studyStore.process.exam.examCode,
						learningType: studyStore.process.exam.learningType,
					},
				},
				r => {
					setTimeout(() => {
						if (isLog) console.log('-CORE- init2222- r -', r);
						initExams(r);
					}, 1000);
				}
			);
		} else if (studyStore.process.exam.learningStatus === 'C') {
			getAnswer(
				{
					type: 'core',
					data: {
						examName: studyStore.process.exam.examCode,
						learningType: studyStore.process.exam.learningType,
					},
				},
				r => {
					setTimeout(() => {
						if (isLog) console.log('-CORE- w6666- r -', r);
						initExams(r);
					}, 1000);
				}
			);
		} else if (studyStore.process.exam.learningStatus === 'W') {
			setTimeout(() => {
				if (isLog) console.log('-CORE- w7777- .  ');
				initExams();
			}, 1000);
		}
	}
};
onMounted(() => {
	init();
	let data = {
		menuName: route.path.split('/').join(''),
		learningTypeCode:
			learningType[studyStore.process.exam.learningType || 'NORMAL'].code,
		examName: studyStore.process.exam.examCode + '_C',
		groupIndex: studyStore?.suggestionIdx,
	};
	monitoringLog(data, res => {
		console.log('coreReading monitoringLog API response ===', res);
	});

	if (
		process.env.NODE_ENV === 'local' ||
		process.env.NODE_ENV === 'development' ||
		localStorage.getItem('videoSuperPass')
	) {
		visibleAnswer.value = true;
	}
	//2024-02-20 pby NewDreams 레슨 시작 API 호출
	callNewDreamsStartTime(
		{
			mbrNo: gStore.userInfo.loginId,
			corsCd: studyStore.level,
			setCd: studyStore.lesson,
		},
		res => {
			console.log('coreReading callNewDreamsStartTime API response ===', res);
		}
	);
});
const startTimer = () => {
	checkProgress(rs => {
		//2023-01-04 pby KRT-2190 추천학습중 맞춤학습 진도가 변경된 경우 학습 알럿 표출 안함
		const learningTypeCodeFlag =
			learningType[studyStore.process.exam.learningType].code;
		if (rs.modifyProgressFlag && learningTypeCodeFlag == '1') {
			dStore.openAlertDialog({
				//2023-12-06 pby KRT-1709 진도수정 기능 개선 기능 추가
				//message: '학습 진도가 ' + (rs.modifyProgressFlag ? '수정' : '리셋') + '되었습니다.\n 다시 학습을 진행해 주세요.',
				//2023-12-11 pby KRT-2153 -- 학습중 진도수정시 알럿 메세지 수정.
				message: '학습 진도가 변경되었습니다. ',
				buttonText: '확인',
				callback: () => {
					//2023-12-06 pby KRT-1709 진도수정 기능 개선 기능 추가
					router.push('/learninghome');
					// sendUserAnswer(end, saveData);
					// postAnswer({ type: 'core', data: saveData }, () => {
					//     studyStore.process.exam.learningStatus = 'I';
					//     if (end) saveResult();
					// });
				},
			});
			//2024-01-04 pby 반영확인
		} else if (rs.modifyProgressFlag && learningTypeCodeFlag == '6') {
			dStore.openAlertDialog({
				//2023-12-06 pby KRT-1709 진도수정 기능 개선 기능 추가
				//message: '학습 진도가 ' + (rs.modifyProgressFlag ? '수정' : '리셋') + '되었습니다.\n 다시 학습을 진행해 주세요.',
				//2023-12-11 pby KRT-2153 -- 학습중 진도수정시 알럿 메세지 수정.
				message:
					'학습 진도가 수정되었습니다. 현재 학습이 끝나면 진도가 변경됩니다.',
				buttonText: '확인',
				callback: () => {},
			});
		} else {
			//  시작시간 세팅 -읽기용
			// console.log('시작 지점');
			let startTs = Date.now();
			startTsGlobal = startTs;
			isKreadVisible.value = false;
			startTime = moment(startTs);
			dStore.openModal(false);
			cornerTime.passageReadStartTs = moment(startTs).format(
				'YYYY-MM-DD HH:mm:ss'
			);
			cornerTime.cornerLearningStartTs = moment(startTs).format(
				'YYYY-MM-DD HH:mm:ss'
			);
			cornerLearningBaseTime = moment(startTs);

			const learningData = {
				id: studyStore.process.exam.examCode + '_C',
				type: 'passageRead',
				startTs: startTs,
				startTime: moment(startTs).format('YYYY-MM-DD HH:mm:ss'),
				endTime: null,
				learningHistorySeq: studyStore.process.learningHistorySeq,
			};
			learningDataList.value.push(learningData);
			// 지문학습 시작
			postCornerStart(
				{
					level: studyStore.level,
					lesson: studyStore.lesson,
					areaCode: studyStore.process.exam.areaCode,
					examName: studyStore.process.exam.examCode + '_C',
					learningType: studyStore.process.exam.learningType,
				},
				rs => {
					studyStore.process.learningHistorySeq = rs.learningHistorySeq;
				}
			);

			//k.u.j 성장판 2.0 오늘의 학습 api call
			monitoringTodayLearningStudy({
				learningHistorySeq: studyStore.process.exam.learningHistorySeq,
				eventTypeCode: 2,
			});
		}
	});
};
const stopTimer = () => {
	if (!isTooFast) {
		let item = learningDataList.value.find(function (element) {
			return element.id === studyStore.process.exam.examCode + '_C';
		});
		if (!item) {
			item = {};
			item.startTs = startTsGlobal;
			item.startTime = moment(item.startTs).format('YYYY-MM-DD HH:mm:ss');
			cornerTime.passageReadStartTs = item.startTime;
		}

		let endTs = Date.now();
		item.endTs = endTs;
		item.elapsedTime = item.endTs - item.startTs;
		item.endTime = moment(endTs).format('YYYY-MM-DD HH:mm:ss');
		time.value = moment(item.elapsedTime).format('mm분 ss초');
		problems[problemOrder.value]['answerEndTs'] = item.endTime;
		cornerTime.passageReadEndTs = item.endTime;
		cornerTime.passageReadTime = item.elapsedTime;
		problems[problemOrder.value]['elapsedTime'] = item.elapsedTime;

		//권장읽기 시간과 실제 지문을 읽은 시간을 비교하여 차이를 표시함
		const suggestedReadTime = Number(data.value?.etcInfo.solveTime) * 1000;

		diffTime.value = suggestedReadTime - cornerTime.passageReadTime;
		readBtn.value = false;
		// if (isTooFast) {
		//   msg.value = '지문의 내용을 이해하면서 읽도록 합니다.'
		// }
		dStore.openModal(true);
		const params = {
			examName: studyStore.process.exam.examCode + '_C',
			learningType: studyStore.process.exam.learningType,
			passageReadStartTs: cornerTime.passageReadStartTs,
			passageReadEndTs: cornerTime.passageReadEndTs,
			passageReadTime: cornerTime.passageReadTime,
		};
		postPassageTime(params);
	} else {
		isTooFast = true;
		msg.value = '너무 빨라요. 내용을 이해하며 정확하게 읽어 보세요.';
	}
};

const setSolveTimeMessage = () => {
	let rsMsg = '';
	//밀리초에서 초로 변환 이유는 하단에 시분초 표시가 초기준으로 되어 있음
	const tmpTime = diffTime.value / 1000;
	if (tmpTime === 0) {
		// rsMsg = '권장읽기 시간을 준수하며 읽었어요.';
		rsMsg =
			'권장 읽기 시간 ' +
			data.value?.standardReadingTime +
			'를 준수하며 읽었어요.';
	} else {
		if (tmpTime > 0) {
			// rsMsg = '표준 읽기 시간보다 ' + (tmpTime + '초 빨리 읽었네요!');
			rsMsg =
				'권장 읽기 시간 ' +
				data.value?.standardReadingTime +
				'보다\n ' +
				(getTimeStringSecondsKor(tmpTime) + ' 빨리 읽었어요.');
		} else {
			// -1 보다 절대값 변환이 맞음
			rsMsg =
				'권장 읽기 시간 ' +
				data.value?.standardReadingTime +
				'보다\n ' +
				(getTimeStringSecondsKor(Math.abs(tmpTime)) + ' 천천히 읽었어요.');
		}
	}
	return rsMsg;
};

const stopNoti = () => {
	if (problemOrder.value === 0) {
		readBtn.value = true;
	}
};

const answerNoti = () => {
	scoreBtn.value = true;
	if (isLog)
		console.log('-CORE- d3333-scoreBtn.value  scoreBtn-', scoreBtn.value);
};

onUnmounted(() => {
	// notif !== null && notif();
	// notiAnswer !== null && notiAnswer();
	// notiNav !== null && notiNav();
	// notiNavBack !== null && notiNavBack();
	// notiInfo !== null && notiInfo();
	isLoading.value = true;
	isKreadVisible.value = true;
	dStore.openModal(false);
});

const onChangeProblems = val => {
	if (val === 'next') problemOrder.value = Number(problemOrder.value) + 1;
	else if (val === 'prev') problemOrder.value = Number(problemOrder.value) - 1;
};

const setInputAnswer = (id, val, typ = true) => {
	// soundEffect('tic');
	tmpAnswer.value = { ...tmpAnswer.value, [id]: val };
	if (problems[problemOrder.value]['result'] != null)
		problems[problemOrder.value]['reAnswer'] = tmpAnswer.value;
	else problems[problemOrder.value]['answer'] = tmpAnswer.value;

	let tmpCheck = 0;
	Object.keys(tmpAnswer.value).forEach(item => {
		if (tmpAnswer.value[item] !== '') {
			tmpCheck += 1;
		}
	});
	if (tmpCheck >= inputIdx.value) answerNoti();
	else {
		notiAnswer !== null && notiAnswer();
		notiAnswer = null;
	}
	if (typ) {
		problem.value = {
			...problem.value,
			answer: { ...tmpAnswer.value },
		};
	}
};

const setEsasyQuestionsResult = () => {
	// soundEffect('result');
	const setNotiNav = () => {
		scoreBtn.value = false;
		if (isLog)
			console.log('-CORE- d4444-scoreBtn.value  scoreBtn-', scoreBtn.value);

		nextBtn.value = true;
		if (isLog) console.log('-CORE- c7777-nextBtn.    -', nextBtn.value);

		if (notiType !== 'first') {
			preBtn.value = true;
		}
	};

	const tmpProblem = problems[problemOrder.value];
	let isCorrectAll = true;
	const answerIdx = problems[problemOrder.value]['result'] != null ? 2 : 1;
	//정답 확인시 풀이시간으로 넣도록 변경
	let item = learningDataList.value.find(function (element) {
		return element.problemId === problems[problemOrder.value].problemId;
	});
	if (item && answerIdx === 1) {
		let endTs = Date.now();
		item.endTs = endTs;
		item.elapsedTime = item.endTs - item.startTs;
		item.endTime = moment(endTs).format('YYYY-MM-DD HH:mm:ss');
		problems[problemOrder.value]['answerEndTs'] = item.endTime;
		problems[problemOrder.value]['elapsedTime'] = item.elapsedTime;
	}

	const tmpAnswerArr =
		problems[problemOrder.value][answerIdx === 2 ? 'reAnswer' : 'answer'];
	const correctArr = [];
	Object.keys(tmpAnswerArr).forEach(key => {
		let finalResult = false;
		const answerDetails = [
			...tmpProblem.data.content.solution.answer.detail,
		].filter(i => {
			return i.ord === Number(key);
		});

		answerDetails.map(item => {
			let tmpUserAnswer = tmpAnswerArr[key];
			let tmpanswer = item['answer'];
			// 공백제거후 비교
			if (item.ignorespace === 'Y') {
				tmpUserAnswer = tmpUserAnswer.replaceAll(' ', '');
				tmpanswer = tmpanswer.replaceAll(' ', '');
			}
			// 대소문자 구분후 비교
			if (item.chkcase === 'N') {
				tmpUserAnswer = tmpUserAnswer.toLowerCase();
				tmpanswer = tmpanswer.toLowerCase();
			}
			if (!finalResult && tmpUserAnswer === tmpanswer) {
				finalResult = true;
			}
		});
		if (finalResult) {
			correctArr.push({
				isCorrect: true,
				answer:
					problems[problemOrder.value][answerIdx === 2 ? 'reAnswer' : 'answer'][
						key
					],
			});
		} else {
			isCorrectAll && (isCorrectAll = false);
			correctArr.push({
				isCorrect: false,
				answer:
					problems[problemOrder.value][answerIdx === 2 ? 'reAnswer' : 'answer'][
						key
					],
			});
		}
	});
	if ((answerIdx === 1 && isCorrectAll) || problemOrder.value === 2) {
		if (isLog)
			console.log('-CORE- -setEsasyQuestionsResult 첫번째  2개짜리 a1111-');
		problems[problemOrder.value]['correctYn'] = true;
		problems[problemOrder.value]['result'] = {
			marking: problemOrder.value === 2 ? '' : 'right',
			answer: correctArr,
		};
		problems[problemOrder.value]['completeYn'] = true;
		soundEffect('correct');
		setNotiNav();
	} else if (answerIdx === 1 && !isCorrectAll) {
		if (isLog)
			console.log('-CORE- -setEsasyQuestionsResult 첫번째 틀림 a2222-');
		problems[problemOrder.value]['correctYn'] = false;
		problems[problemOrder.value]['result'] = {
			marking: 'halfWrong',
			answer: correctArr,
		};
		// msg.value = '오답은 한번 다시 풀 수 있어요.';
		msg.value = '다시 한 번 풀어 보세요.';
		scoreBtn.value = false;
		if (isLog)
			console.log('-CORE- d1111-scoreBtn.value  scoreBtn-', scoreBtn.value);

		soundEffect('halfWrong');
	} else if (answerIdx === 2 && isCorrectAll) {
		if (isLog)
			console.log('-CORE- -setEsasyQuestionsResult 두번째 맞힘 a3333-');
		problems[problemOrder.value]['reCorrectYn'] = true;
		problems[problemOrder.value]['result'] = {
			marking: 'halfRight',
			answer: correctArr,
		};
		problems[problemOrder.value]['completeYn'] = true;
		soundEffect('correct');
		setNotiNav();
	} else if (answerIdx === 2 && !isCorrectAll) {
		if (isLog)
			console.log('-CORE- -setEsasyQuestionsResult 두번째 틀림 a4444-');
		problems[problemOrder.value]['reCorrectYn'] = false;
		problems[problemOrder.value]['result'] = {
			marking: 'wrong',
			answer: correctArr,
		};
		problems[problemOrder.value]['completeYn'] = true;
		msg.value = '';
		soundEffect('wrong');
		setNotiNav();
	}
	notiAnswer = null;
	problem.value = { ...problems[problemOrder.value] };
};

const saveResult = () => {
	if (isViewMode) {
		router.push('/authenticreading');
		studyStore.currentInfo.studyTree = studyStore.currentInfo.studyTree + 1;
	} else {
		postCornerEnd(
			{
				type: 'core',
				data: {
					examName: studyStore.process.exam.examCode + '_C',
					learningType: studyStore.process.exam.learningType,
				},
			},
			() => {
				router.push('/authenticreading');
				//studyStore.process.studyTree = studyStore.process.studyTree + 1;

				//2023-11-08 pby 세션 코드 값 전달 변경
				// 5082: '코어독해',
				// 5083: '본격독해',
				// 5086: '본격독해_확인',
				// 5084: '어휘학습',
				studyStore.process.studyTree = 5083;
			}
		);
	}
};

// krt1626 답변값 널 체크
const invalidAnswer = tmpVal => {
	const result =
		!tmpVal.answer || !tmpVal.answerEndTs || !Object.keys(tmpVal.answer).length;
	if (isLog) console.log('-CORE--inValidAnswer- tmpVal:', tmpVal);
	return result;
};

const highlightContents = ref();
const submitAnswer = (num, end = false) => {
	if (isLog)
		console.log('-CORE-submitAnswer-num, end problems-', num, end, problems);
	let tmpVal = { ...problems[num] };
	if (isLog) console.log('-CORE-submitAnswer- tmpVal-', tmpVal);
	//나갔다 들어온 경우 해당 시간이 갱신되는 문제가 있어
	if (tmpVal.elapsedTime < 30 && videoTime.videoViewEndTs == null) {
		return;
	}
	if (invalidAnswer(tmpVal)) {
		router.go(router.currentRoute);
		return;
	}

	let endTs = Date.now();
	let item = learningDataList.value.find(function (element) {
		return element.problemId === tmpVal.problemId;
	});
	if (item) {
		if (
			typeof problems[num]['cornerStartTs'] == 'undefined' ||
			problems[num]['cornerStartTs'] === null
		) {
			problems[num]['cornerStartTs'] = item.startTime;
		}
		problems[num]['cornerEndTs'] = moment(endTs).format('YYYY-MM-DD HH:mm:ss');
		problems[num]['cornerElapsedTime'] = endTs - item.startTs;
	}

	let tmpCornerTime = {
		cornerLearningStartTs: problems[num].cornerStartTs,
		cornerLearningEndTs: problems[num].cornerEndTs,
		cornerLearningTime: problems[num].cornerElapsedTime,
	};

	// if (isLog) console.log('-CORE-submitAnswer-tmpVal.  -', tmpVal);
	// const userAnsweredText = getUserAnswer(tmpVal.reAnswer || tmpVal.answer);
	// if (isLog) console.log('-CORE-userAnsweredText--', userAnsweredText);

	tmpVal.answer = JSON.stringify(tmpVal.answer);
	tmpVal.reAnswer = tmpVal.reAnswer
		? JSON.stringify(tmpVal.reAnswer)
		: tmpVal.reAnswer;
	tmpVal.correct = JSON.stringify(tmpVal.rightAnswer);
	// tmpVal.elapsedTime = tmpVal.elapsedTime;

	try {
		// 비디오 시청 완료 시 하이라이트 지문 넘어가도록 수정
		if (!end) {
			tmpVal.reviewContents =
				isChangeHeader.value && document.getElementById('header_box')
					? document.getElementById('header_box')?.innerHTML
					: null;
			highlightContents.value = tmpVal.reviewContents;
		} else {
			tmpVal.reviewContents = highlightContents.value;
		}
	} catch (error) {
		tmpVal.reviewContents = null;
	}
	tmpVal.answerStatus = 'COMPLETE';

	delete tmpVal.data;
	delete tmpVal.result;
	delete tmpVal.rightAnswer;

	delete tmpVal.cornerStartTs;
	delete tmpVal.cornerEndTs;
	delete tmpVal.cornerElapsedTime;

	const saveData = {
		examName: studyStore.process.exam.examCode + '_C',
		exprVersion: studyStore.exprVersion,
		learningType: studyStore.process.exam.learningType,
		cornerTime: tmpCornerTime,
		submission: tmpVal,
	};

	if (!isViewMode) {
		//2024-01-04 pby 반영확인
		checkProgress(rs => {
			//2023-01-04 pby KRT-2190 추천학습중 맞춤학습 진도가 변경된 경우 학습 알럿 표출 안함
			const learningTypeCodeFlag =
				learningType[studyStore.process.exam.learningType].code;
			if (rs.modifyProgressFlag && learningTypeCodeFlag == '1') {
				dStore.openAlertDialog({
					//2023-12-06 pby KRT-1709 진도수정 기능 개선 기능 추가
					//message: '학습 진도가 ' + (rs.modifyProgressFlag ? '수정' : '리셋') + '되었습니다.\n 다시 학습을 진행해 주세요.',
					//2023-12-11 pby KRT-2153 -- 학습중 진도수정시 알럿 메세지 수정.
					message: '학습 진도가 변경되었습니다. ',
					buttonText: '확인',
					callback: () => {
						//2023-12-06 pby KRT-1709 진도수정 기능 개선 기능 추가
						router.push('/learninghome');
						// sendUserAnswer(end, saveData);
						// postAnswer({ type: 'core', data: saveData }, () => {
						//     studyStore.process.exam.learningStatus = 'I';
						//     if (end) saveResult();
						// });
					},
				});
				//2024-01-04 pby 반영확인
			} else if (rs.modifyProgressFlag && learningTypeCodeFlag == '6') {
				dStore.openAlertDialog({
					//2023-12-06 pby KRT-1709 진도수정 기능 개선 기능 추가
					//message: '학습 진도가 ' + (rs.modifyProgressFlag ? '수정' : '리셋') + '되었습니다.\n 다시 학습을 진행해 주세요.',
					//2023-12-11 pby KRT-2153 -- 학습중 진도수정시 알럿 메세지 수정.
					message:
						'학습 진도가 수정되었습니다. 현재 학습이 끝나면 진도가 변경됩니다.',
					buttonText: '확인',
					callback: () => {},
				});
			} else {
				if (isLog) console.log('-CORE-postAnswer22222-dddbb  -', saveData);
				// sendUserAnswer(end, saveData);
				//msg.value = moment(saveData.submission.elapsedTime).format('mm분 ss초');
				postAnswer({ type: 'core', data: saveData }, () => {
					studyStore.process.exam.learningStatus = 'I';
					if (end) saveResult();
				});
			}
		});
		//2024-01-04 pby 반영확인
	} else if (end) {
		if (isLog) console.log('-CORE-postAnswer3333333333--');
		dStore.openAlertDialog({
			message: '현재 진행중인 학습으로 이동합니다.',
			cancel: '닫기',
			ok: '확인',
			callback: () => {
				studyStore.currentInfo = null;
				router.push(
					studyStore.process.studyTree === 5083
						? '/authenticreading'
						: studyStore.process.studyTree === 5084
						? '/vocabularylearning'
						: 'corereading'
				);
			},
		});
	}

	cornerTime.cornerLearningStartTs = moment().format('YYYY-MM-DD HH:mm:ss');
};

const resetValue = () => {
	isLoading.value = true;
	isKreadVisible.value = false;
	isViewMode = false;
	videoHeader.value = false;
	data.value = null;
	questionHeader.value = null;
	bookNm.value = null;
	videoStudy.value = false;
	inputIdx.value = 0;
	problemOrder.value = 0;
	nextBtn.value = false;
	if (isLog) console.log('-CORE- c8888-nextBtn.    -', nextBtn.value);

	preBtn.value = false;
	readBtn.value = false;
	scoreBtn.value = false;
	if (isLog)
		console.log('-CORE- d2222-scoreBtn.value  scoreBtn-', scoreBtn.value);

	videoComplete.value = false;
	videoHeader.value = false;
	problem.value = null;
	answer.value = false;
	tmpAnswer.value = false;
	videoUrl.value = false;
	time.value = null;
	notiType = 'first';
	problems = {};
	videoTime = {
		videoViewStartTs: null,
		videoViewEndTs: null,
		videoViewTime: 0,
	};
	cornerTime = {
		passageReadStartTs: null,
		passageReadEndTs: null,
		passageReadTime: 0,
		videoViewStartTs: null,
		videoViewEndTs: null,
		videoViewTime: 0,
		cornerLearningStartTs: null,
		cornerLearningEndTs: null,
		cornerLearningTime: 0,
	};
};
</script>

<style scoped lang="scss">
.word-chart_item {
	padding: 0px 20px;
	text-align: center;
	font-size: 1.83vmin;
	font-weight: 500;
	color: #8e8e8e;
}

.modal-model {
	// position: absolute;
	// bottom: 50px;
	// right: 20px;
	// margin-left: -48px;
	// margin-top: -48px;
	// z-index: 100;
	// width: 300px;
	// height: calc(100% - 120px);
	// background-color: white;
	// border-radius: 20px;
	// padding: 20px;
	// opacity: 0.8;
	width: 40%;
	height: calc(100% - 120px);
	position: absolute;
	z-index: 100;
	right: 20px;
	// opacity: 0.8;
	top: 70px;
}

.reading {
	&__modal {
		.q-card {
			width: 29vw;
			height: 66.6vh;
			padding: 5.8vh 3.33vmin 3.33vmin;
			@include border-radius(3.33vmin);
			display: flex;
			flex-direction: column;
			justify-content: space-between;
			overflow: hidden;

			p {
				margin-bottom: 0;
			}

			.clock__img {
				width: 50%;
				max-width: 240px;
				margin: 3.83vmin auto;
			}

			.reading__btn {
				button {
					width: 100%;
					margin-top: 3.33vmin;
					padding: 2.75vmin 2.83vmin;
					@include border-radius(1.33vmin);
					font-size: 1.2vw;
					font-weight: 700;
					line-height: 1.6vw;
				}
			}
		}
	}
}

::v-deep {
	.q-badge {
		margin-bottom: 0.75vmin;
		margin-left: 11.17vmin;
		padding: 0.83vmin 1.33vmin;
		@include border-radius(1.83vmin);
		background: $color_gray_300;
		font-size: 1vw;
		font-weight: 500;
		color: $color_gray_800;
		line-height: 1.3vw;
	}

	.answer {
		&--next {
			.q-icon {
				margin: 0 auto;
				font-size: 1.3vw;
			}
		}

		&--prev {
			.q-icon {
				margin: 0 auto;
				font-size: 1.3vw;
			}
		}
	}

	.q-page {
		.q-chip {
			margin: 0 0 2.67vmin;
			padding: 0.83vmin 1.33vmin;
			@include border-radius(1.83vmin);
			background: $color_gray_300;
			font-size: 1vw;
			font-weight: 500;
			color: $color_gray_800;
			line-height: 1.3vw;
		}
	}
}

.page {
	padding-top: 3.75vmin;

	&__txt {
		margin-bottom: 3.5vmin;
	}

	&__btn {
		text-align: center;

		button {
			width: 27%;
			max-width: 533px;
			padding: 1.92vmin 2.83vmin;
			@include border-radius(1.33vmin);
			font-size: 1.2vw;
			font-weight: 700;
			line-height: 1.6vw;
		}
	}

	h2 {
		margin-bottom: 0.83vmin;
	}
}

.kread {
	&__logo {
		justify-content: center;
		align-items: center;
		line-height: inherit;
		//width:100%;
		//height: 4.16vmin;
		//font-size: 2.5vmin;
		//color:#1976D2;
	}

	&__img {
		display: block;
		width: 6%;
		max-width: 105.81px;

		img {
			width: 100%;
		}
	}

	&__number {
		display: block;
		margin-left: 0.33vmin;
		padding: 0.83vmin 1.71vmin;
		@include border-radius(100%);
		background: $color_primary;
		font-size: 1.1vw;
		font-weight: 700;
		color: $color_white;
		line-height: 1.5vw;
	}
}

.sub-title {
	margin-bottom: 1.67vmin;
}

.chart {
	&__txt {
		width: 35%;
		max-width: 641px;
		height: 30%;
		max-height: 306px;
		margin: 0 auto;
	}

	&__list {
		align-items: center;
		width: 25%;
		max-width: 499px;
		margin: 1.33vmin auto 5.42vmin;
	}

	&__item {
		flex-grow: 1;
		font-size: 1.1vw;
		font-weight: 500;
		color: $color_gray_600;
		text-align: center;
		line-height: 1.4vw;

		span {
			display: block;
			margin-top: 0.67vmin;
			font-size: 1.7vw;
			font-weight: 700;
			color: $color_gray_900;
			line-height: 2.4vw;
		}
	}
}

.passage,
.answer {
	height: calc((var(--vh, 1vh) * 100) - 82px);
	margin-top: 1.99vmin;
}

.passage {
	+ .answer {
		&::before {
			content: '';
			position: absolute;
			top: 46%;
			left: 0;
			width: 1px;
			height: 91%;
			max-height: 974px;
			background: $color_gray_500;
			@include transform(translateY(-50%));
		}
	}
}

.answer {
	position: relative;
	// padding: 0 4.17vmin;

	&__scroll {
		padding: 0 5.17vmin 3.33vmin 4.08vmin;
		// padding-right: 5.17vmin;
		// padding-bottom: 3.33vmin;
	}

	&--retry {
		padding: 1.33vmin 3vmin !important;
		margin-right: 3.33vmin;
		font-size: 1.3vw;
		font-weight: 500;
		line-height: 2.1vw;
	}

	&--next {
		width: 4.9vw;
		height: 4.9vw;
		margin-right: 3.33vmin;
	}

	&--prev {
		width: 3.5vw;
		height: 3.5vw;
		margin-left: 2.5vmin;
	}

	&--txt {
		padding: 2.75vmin 3.42vmin !important;
		margin-right: 3.33vmin;
		font-size: 1.2vw;
		font-weight: 700;
		line-height: 1.6vw;
	}
}

::v-deep {
	.q-scrollarea__content {
		padding-bottom: 3.33vmin;
	}

	.q-scrollarea__bar--v,
	.q-scrollarea__thumb--v {
		width: 0.3vw;
	}
}
</style>
